import React from 'react';

import TeaserInfo from '@fec/frontend/elements/text/teaser-info/teaser-info';

/**
 * Render the provided search result and do some crazy stuff with refs for focus handling:
 * - backToTop: first item in the list must have set the first item ref to reset the focus
 * - on pagebreak. Take advantage on the fact that both refs never exists on the same item.
 */
const AlgoliaResult = React.forwardRef((props, ref) => {
  const {
    urn,
    image,
    imageDescription,
    link,
    pageBreak,
    title,
    kicker,
    description,
    isVisited,
    visitedText,
    updateTime,
    mediaIcon,
    mediaDescription,
  } = props.result;

  return (
    <li className="collection-ng__teaser-item js-teaser-ng-item" key={urn}>
      <a
        className="teaser-ng js-teaser-ng teaser-ng--article"
        href={link}
        ref={pageBreak ? ref : null}>
        {image && (
          <div className="teaser-ng__medium">
            <picture className="image-ng">
              <img
                className="image-ng__img"
                alt={imageDescription}
                src={image}
              />
            </picture>
          </div>
        )}

        <div className="teaser-ng__content" role="text">
          <div className="teaser-ng__text">
            <div className="teaser-ng__kicker">{kicker}</div>
            <span className="teaser-ng__title">{title}</span>
            <p
              className="teaser-ng__lead"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        </div>

        <div className="teaser-ng__extras">
          <div className="teaser-meta js-teaser-meta" role="text">
            <div className="teaser-meta__ltr js-teaser-meta__ltr">
              {isVisited && (
                <TeaserInfo
                  styleModifier="teaser-info--visited teaser-info--uppercase"
                  text={visitedText}
                />
              )}
              <TeaserInfo
                styleModifier="teaser-info--with-updates teaser-info--uppercase"
                text={updateTime}
              />
              {mediaIcon && (
                <TeaserInfo
                  styleModifier={`teaser-info--${mediaIcon} teaser-info--uppercase`}
                  text={mediaDescription}
                />
              )}
            </div>
          </div>
        </div>
      </a>
    </li>
  );
});
export default AlgoliaResult;
